import axios from "axios";
import {
  toast
} from "react-toastify";
import {
  push
} from "connected-react-router";

export const FORUM_GET_ARTICLES_REQUEST = "FORUM_GET_USERS_REQUEST";
export const FORUM_GET_ARTICLES_SUCCESS = "FORUM_GET_ARTICLES_SUCCESS";
export const FORUM_GET_ARTICLES_FAIL = "FORUM_GET_ARTICLES_FAIL";
export const getArticles = params => dispatch => {
  dispatch({
    type: FORUM_GET_ARTICLES_REQUEST
  });
  axios
    .request({
      url: "dashboard/forum_posts",
      params: params,
      method: "GET"
    })
    .then(({
      data
    }) => {
      if (data.success) {
        dispatch({
          type: FORUM_GET_ARTICLES_SUCCESS,
          msg: data.message,
          data: data.data
        });
      } else {
        dispatch({
          type: FORUM_GET_ARTICLES_FAIL,
          msg: data.message,
          errors: data.errors ? data.errors : {}
        });
        // toast.warn(data.message);
      }
    });
};

export const FORUM_GET_CATEGORIES_REQUEST = "FORUM_GET_CATEGORIES_REQUEST";
export const FORUM_GET_CATEGORIES_SUCCESS = "FORUM_GET_CATEGORIES_SUCCESS";
export const FORUM_GET_CATEGORIES_FAIL = "FORUM_GET_CATEGORIES_FAIL";
export const getCategories = params => dispatch => {
  dispatch({
    type: FORUM_GET_CATEGORIES_REQUEST
  });
  axios
    .request({
      url: "categories",
      params: {
        post_type: "forum_post"
      },
      method: "GET"
    })
    .then(({
      data
    }) => {
      if (data.success) {
        dispatch({
          type: FORUM_GET_CATEGORIES_SUCCESS,
          msg: data.message,
          data: data.data
        });
      } else {
        dispatch({
          type: FORUM_GET_CATEGORIES_FAIL,
          msg: data.message,
          errors: data.errors ? data.errors : {}
        });
        // toast.warn(data.message);
      }
    });
};

export const FORUM_REMOVE_ARTICLE_REQUEST = "FORUM_REMOVE_ARTICLE_REQUEST";
export const FORUM_REMOVE_ARTICLE_SUCCESS = "FORUM_REMOVE_ARTICLE_SUCCESS";
export const FORUM_REMOVE_ARTICLE_FAIL = "FORUM_REMOVE_ARTICLE_FAIL";
export const removeArticle = ({
  post_id,
  path
}) => dispatch => {
  dispatch({
    type: FORUM_REMOVE_ARTICLE_REQUEST
  });
  axios
    .request({
      url: "dashboard/post/remove",
      data: {
        post_id
      },
      method: "post"
    })
    .then(({
      data
    }) => {
      if (data.success) {
        dispatch({
          type: FORUM_REMOVE_ARTICLE_SUCCESS
        });
        toast.success(data.message);
        if (path === 'user') {

          dispatch(push("/dash/user/management/forums"));
        } else {
          dispatch(push("/dash/admin/bbs"));
        }

      } else {
        dispatch({
          type: FORUM_REMOVE_ARTICLE_FAIL,
          msg: data.message,
          errors: data.errors ? data.errors : {}
        });
        // toast.warn(data.message);
      }
    });
};

export const FORUM_GET_ARTICLE_REQUEST = "FORUM_GET_ARTICLE_REQUEST";
export const FORUM_GET_ARTICLE_SUCCESS = "FORUM_GET_ARTICLE_SUCCESS";
export const FORUM_GET_ARTICLE_FAIL = "FORUM_GET_ARTICLE_FAIL";
export const getArticle = id => dispatch => {
  dispatch({
    type: FORUM_GET_ARTICLE_REQUEST
  });
  axios
    .request({
      url: "dashboard/post",
      params: {
        post_id: id
      },
      method: "GET"
    })
    .then(({
      data
    }) => {
      if (data.success) {
        dispatch({
          type: FORUM_GET_ARTICLE_SUCCESS,
          msg: data.message,
          data: data.data
        });
      } else {
        dispatch({
          type: FORUM_GET_ARTICLE_FAIL,
          msg: data.message,
          errors: data.errors ? data.errors : {}
        });
        // toast.warn(data.message);
      }
    });
};

export const FORUM_EDIT_ARTICLE_REQUEST = "FORUM_EDIT_ARTICLE_REQUEST";
export const FORUM_EDIT_ARTICLE_SUCCESS = "FORUM_EDIT_ARTICLE_SUCCESS";
export const FORUM_EDIT_ARTICLE_FAIL = "FORUM_EDIT_ARTICLE_FAIL";
export const editArticle = ({
  post_id,
  category_ids,
  title,
  body,
  status
}) => dispatch => {
  let params = new FormData(); //如果需要上传多张图片,需要遍历数组,把图片的路径数组放入formData中
  params.append("post_id", post_id);
  params.append("category_ids", category_ids);
  params.append("title", title);
  params.append("body", body);
  params.append("status", status);
  dispatch({
    type: FORUM_EDIT_ARTICLE_REQUEST
  });
  axios
    .request({
      url: "dashboard/forum_post/edit",
      data: params,
      method: "POST",
      headers: {
        "Content-Type": "multipart/form-data"
      }
    })
    .then(({
      data
    }) => {
      if (data.success) {
        dispatch({
          type: FORUM_EDIT_ARTICLE_SUCCESS,
          msg: data.message,
          data: data.data
        });
        dispatch(push("/dash/user/management/forums"));
      } else {
        dispatch({
          type: FORUM_EDIT_ARTICLE_FAIL,
          msg: data.message,
          errors: data.errors ? data.errors : {}
        });
        // toast.warn(data.message);
      }
    });
};

export const FORUM_CREATE_ARTICLE_REQUEST = "FORUM_CREATE_ARTICLE_REQUEST";
export const FORUM_CREATE_ARTICLE_SUCCESS = "FORUM_CREATE_ARTICLE_SUCCESS";
export const FORUM_CREATE_ARTICLE_FAIL = "FORUM_CREATE_ARTICLE_FAIL";
export const createArticle = ({
  category_ids,
  // title,
  // body,
  // status
}) => dispatch => {
  // let params = new FormData(); //如果需要上传多张图片,需要遍历数组,把图片的路径数组放入formData中
  // params.append("category_ids", category_ids);
  // params.append("title", title);
  // params.append("body", body);
  // params.append("status", status);
  dispatch({
    type: FORUM_CREATE_ARTICLE_REQUEST
  });
  axios
    .request({
      url: "dashboard/forum_post/create",
      data: {
        category_ids
      },
      method: "POST",
    })
    .then(({
      data
    }) => {
      if (data.success) {
        dispatch({
          type: FORUM_CREATE_ARTICLE_SUCCESS,
          msg: data.message,
          data: data.data
        });
        dispatch(push("/dash/user/management/forums/" + data.data.id + "/edit"));
      } else {
        dispatch({
          type: FORUM_CREATE_ARTICLE_FAIL,
          msg: data.message,
          errors: data.errors ? data.errors : {}
        });
        // toast.warn(data.message);
      }
    });
};